import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import GatewayVpnTopologyTable from './GatewayVpnTopologyTable';

const pageSchema = GatewayGetSchema.pages.vpnInternalNetworkTopology;
const pageId = pageSchema.pageId;

function GatewayVpnInternalNetworkTopology({
    gatewayObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const pageData = gatewayObject[pageId];

    const topologyList        = pageData[pageSchema.topologyList];
    const excludeTopologyList = pageData[pageSchema.excludeTopologyList];

    const setPageData = useCallback((paramName, newValue) => {
        setGatewayData([pageId, paramName], newValue);
    }, [setGatewayData]);

    const setTopologyList = useCallback((newValue) => {
        setPageData(pageSchema.topologyList, newValue);
    }, [setPageData]);

    const setExcludeTopologyList = useCallback((newValue) => {
        setPageData(pageSchema.excludeTopologyList, newValue);
    }, [setPageData]);

    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY.LINE1')}</SMCLabel>
            <GatewayVpnTopologyTable
                topologyList={topologyList}
                setTopologyList={setTopologyList}
            />
            <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.VPN.INTERNAL_NET_TOPOLOGY.LINE2')}</SMCLabel>
            <GatewayVpnTopologyTable
                topologyList={excludeTopologyList}
                setTopologyList={setExcludeTopologyList}
            />
        </EditorLayout>
    );
}

export default GatewayVpnInternalNetworkTopology;